var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "p-4 bg-white"
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('b-row', {
    staticClass: "mb-5"
  }, [_c('b-col', {
    attrs: {
      "md": 12
    }
  }, [_c('CustomNav', {
    attrs: {
      "items": _vm.tabs
    },
    on: {
      "item-click": function itemClick(tab) {
        return _vm.activeTab = tab;
      }
    }
  })], 1)], 1), _c('b-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeTab == 'general',
      expression: "activeTab == 'general'"
    }]
  }, [_c('b-col', {
    attrs: {
      "md": _vm.isFormShippment ? 12 : 6
    }
  }, [_c('section', [_c('div', {
    staticClass: "section-title"
  }, [_c('h6', [_vm._v("COMPANY INFO")])]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Company Name *"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('div', [_vm._v(" Company Name "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v("*")])])];
      },
      proxy: true
    }])
  }, [_c('b-form-input', {
    attrs: {
      "plain": "",
      "required": ""
    },
    model: {
      value: _vm.form.accountName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "accountName", $$v);
      },
      expression: "form.accountName"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Customer Status *"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('div', [_vm._v(" Customer Status "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v("*")])])];
      },
      proxy: true
    }])
  }, [_c('b-form-select', {
    attrs: {
      "required": "",
      "options": _vm.cutomerStatusOptions,
      "plain": ""
    },
    model: {
      value: _vm.form.cutomerStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cutomerStatus", $$v);
      },
      expression: "form.cutomerStatus"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Customer Class *"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('div', [_vm._v(" Customer Class "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v("*")])])];
      },
      proxy: true
    }])
  }, [_c('b-form-select', {
    attrs: {
      "plain": "",
      "options": _vm.cutomerClassOptions,
      "required": ""
    },
    model: {
      value: _vm.form.cutomerClass,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cutomerClass", $$v);
      },
      expression: "form.cutomerClass"
    }
  })], 1)], 1)], 1)], 1), _c('section', {
    staticClass: "mb-4"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Country *"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('div', [_vm._v(" Country "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v("*")])])];
      },
      proxy: true
    }])
  }, [_c('v-select', {
    attrs: {
      "options": _vm.countryOptions,
      "placeholder": "Select Country",
      "label": "text",
      "reduce": function reduce(option) {
        return option.value;
      },
      "clearable": false
    },
    model: {
      value: _vm.form.country,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "country", $$v);
      },
      expression: "form.country"
    }
  })], 1)], 1), _vm.form.country == 'ID' ? _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Province *"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('div', [_vm._v(" Province "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v("*")])])];
      },
      proxy: true
    }], null, false, 1842651677)
  }, [_c('v-select', {
    attrs: {
      "options": _vm.option.provience,
      "required": "",
      "label": "name",
      "reduce": function reduce(val) {
        return val.id;
      },
      "plain": "",
      "placeholder": "Select Province"
    },
    on: {
      "input": _vm.onProvinceChange
    },
    model: {
      value: _vm.form.province,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "province", $$v);
      },
      expression: "form.province"
    }
  })], 1)], 1) : _vm._e()], 1), _vm.form.country == 'ID' ? [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "City *"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('div', [_vm._v(" City "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v("*")])])];
      },
      proxy: true
    }], null, false, 2119842656)
  }, [_c('v-select', {
    attrs: {
      "label": "name",
      "reduce": function reduce(val) {
        return val.id;
      },
      "options": _vm.option.cities,
      "required": "",
      "placeholder": "Select City",
      "disabled": !_vm.form.province
    },
    on: {
      "input": _vm.onCityChange
    },
    model: {
      value: _vm.form.city,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "city", $$v);
      },
      expression: "form.city"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "District *"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('div', [_vm._v(" District "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v("*")])])];
      },
      proxy: true
    }], null, false, 4282933281)
  }, [_c('v-select', {
    attrs: {
      "label": "name",
      "reduce": function reduce(val) {
        return val.id;
      },
      "required": "",
      "options": _vm.option.districts,
      "placeholder": "Select District",
      "disabled": !_vm.form.city
    },
    on: {
      "input": _vm.onDistrictChange
    },
    model: {
      value: _vm.form.district,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "district", $$v);
      },
      expression: "form.district"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Sub District"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "name",
      "reduce": function reduce(val) {
        return val.id;
      },
      "options": _vm.option.villages,
      "placeholder": "Select Sub District",
      "disabled": !_vm.form.district
    },
    model: {
      value: _vm.form.subDistrict,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "subDistrict", $$v);
      },
      expression: "form.subDistrict"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Postal Code"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "placeholder": "Select Postal Code"
    },
    model: {
      value: _vm.form.postalCode,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "postalCode", $$v);
      },
      expression: "form.postalCode"
    }
  })], 1)], 1)], 1)] : _vm._e(), _c('b-form-group', {
    attrs: {
      "label": "Address"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "2"
    },
    model: {
      value: _vm.form.address,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "address", $$v);
      },
      expression: "form.address"
    }
  })], 1)], 2)]), _c('b-col', {
    attrs: {
      "md": _vm.isFormShippment ? 12 : 6
    }
  }, [_c('section', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('h6', [_vm._v("ADDITIONAL INFO")])]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Logo"
    }
  }, [_c('b-form-file', {
    attrs: {
      "browse-text": "Browse"
    },
    model: {
      value: _vm.form.logo,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "logo", $$v);
      },
      expression: "form.logo"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Web"
    }
  }, [_c('b-form-input', {
    on: {
      "input": _vm.onWebChange
    },
    model: {
      value: _vm.form.web,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "web", $$v);
      },
      expression: "form.web"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Fax"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: _vm.form.fax,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "fax", $$v);
      },
      expression: "form.fax"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Assistance"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.form.assistance,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "assistance", $$v);
      },
      expression: "form.assistance"
    }
  })], 1)], 1)], 1)], 1), _c('section', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('h6', [_vm._v("ADDITIONAL CONTACT")])]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Name"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.form.picName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "picName", $$v);
      },
      expression: "form.picName"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Job Title"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.form.picJobTitle,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "picJobTitle", $$v);
      },
      expression: "form.picJobTitle"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Email Office"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.form.emailOffice,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "emailOffice", $$v);
      },
      expression: "form.emailOffice"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Email"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.form.email,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "email", $$v);
      },
      expression: "form.email"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Phone"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.form.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "phone", $$v);
      },
      expression: "form.phone"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Mobile Phone"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.form.mobile,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "mobile", $$v);
      },
      expression: "form.mobile"
    }
  })], 1)], 1)], 1)], 1)])], 1), _c('b-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeTab == 'billing',
      expression: "activeTab == 'billing'"
    }]
  }, [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('section', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('h6', [_vm._v("BILL TO ADDRESS")])]), _c('b-row', {
    staticClass: "mb-3"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "custom-checkbox",
    on: {
      "change": _vm.onSameAsGeneralChange
    },
    model: {
      value: _vm.sameAsGeneralAddress,
      callback: function callback($$v) {
        _vm.sameAsGeneralAddress = $$v;
      },
      expression: "sameAsGeneralAddress"
    }
  }, [_c('span', [_vm._v("Copy With General Address")])])], 1)], 1), _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Country *"
    }
  }, [_c('v-select', {
    attrs: {
      "options": _vm.countryOptions,
      "placeholder": "Select Country",
      "label": "text",
      "reduce": function reduce(option) {
        return option.value;
      },
      "clearable": false,
      "disabled": _vm.sameAsGeneralAddress
    },
    model: {
      value: _vm.form.countryBill,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "countryBill", $$v);
      },
      expression: "form.countryBill"
    }
  })], 1)], 1), _vm.form.countryBill == 'ID' ? _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Province *"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('div', [_vm._v(" Province "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v("*")])])];
      },
      proxy: true
    }], null, false, 1842651677)
  }, [_c('v-select', {
    attrs: {
      "options": _vm.sameAsGeneralAddress ? _vm.option.provience : _vm.optionBill.provience,
      "required": "",
      "label": "name",
      "reduce": function reduce(val) {
        return val.id;
      },
      "plain": "",
      "placeholder": "Select Province",
      "disabled": _vm.sameAsGeneralAddress
    },
    on: {
      "input": _vm.onProvinceChangeBill
    },
    model: {
      value: _vm.form.provinceBill,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "provinceBill", $$v);
      },
      expression: "form.provinceBill"
    }
  })], 1)], 1) : _vm._e()], 1), _vm.form.countryBill == 'ID' ? [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "City *"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('div', [_vm._v(" City "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v("*")])])];
      },
      proxy: true
    }], null, false, 2119842656)
  }, [_c('v-select', {
    attrs: {
      "label": "name",
      "reduce": function reduce(val) {
        return val.id;
      },
      "options": _vm.sameAsGeneralAddress ? _vm.option.cities : _vm.optionBill.cities,
      "required": "",
      "placeholder": "Select City",
      "disabled": _vm.sameAsGeneralAddress || !_vm.form.provinceBill
    },
    on: {
      "input": _vm.onCityChangeBill
    },
    model: {
      value: _vm.form.cityBill,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cityBill", $$v);
      },
      expression: "form.cityBill"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "District *"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('div', [_vm._v(" District "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v("*")])])];
      },
      proxy: true
    }], null, false, 4282933281)
  }, [_c('v-select', {
    attrs: {
      "label": "name",
      "reduce": function reduce(val) {
        return val.id;
      },
      "required": "",
      "options": _vm.sameAsGeneralAddress ? _vm.option.districts : _vm.optionBill.districts,
      "placeholder": "Select District",
      "disabled": _vm.sameAsGeneralAddress || !_vm.form.cityBill
    },
    on: {
      "input": _vm.onDistrictChangeBill
    },
    model: {
      value: _vm.form.districtBill,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "districtBill", $$v);
      },
      expression: "form.districtBill"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Sub District"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "name",
      "reduce": function reduce(val) {
        return val.id;
      },
      "options": _vm.sameAsGeneralAddress ? _vm.option.villages : _vm.optionBill.villages,
      "placeholder": "Select Sub District",
      "disabled": _vm.sameAsGeneralAddress || !_vm.form.districtBill
    },
    model: {
      value: _vm.form.subDistrictBill,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "subDistrictBill", $$v);
      },
      expression: "form.subDistrictBill"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Postal Code"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "placeholder": "Enter Postal Code",
      "disabled": _vm.sameAsGeneralAddress
    },
    model: {
      value: _vm.form.postalCodeBill,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "postalCodeBill", $$v);
      },
      expression: "form.postalCodeBill"
    }
  })], 1)], 1)], 1)] : _vm._e(), _c('b-form-group', {
    attrs: {
      "label": "Address"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "2",
      "disabled": _vm.sameAsGeneralAddress
    },
    model: {
      value: _vm.form.addressBill,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "addressBill", $$v);
      },
      expression: "form.addressBill"
    }
  })], 1), _vm.sameAsGeneralAddress ? _c('b-alert', {
    staticClass: "mt-3 d-flex align-items-center",
    attrs: {
      "show": "",
      "variant": "info"
    }
  }, [_c('i', {
    staticClass: "fas fa-info-circle mr-2"
  }), _vm._v(" Billing address is automatically synced with general address ")]) : _vm._e()], 2)], 1)]), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('section', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('h6', [_vm._v("BILL TO INFO")])]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Account Name"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.form.accountNameBill,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "accountNameBill", $$v);
      },
      expression: "form.accountNameBill"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Attention"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.form.attention,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "attention", $$v);
      },
      expression: "form.attention"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Bussiness"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.form.bussiness1,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "bussiness1", $$v);
      },
      expression: "form.bussiness1"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Fax"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: _vm.form.faxBill,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "faxBill", $$v);
      },
      expression: "form.faxBill"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Email"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "email"
    },
    model: {
      value: _vm.form.emailBill,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "emailBill", $$v);
      },
      expression: "form.emailBill"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Web"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.form.webBill,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "webBill", $$v);
      },
      expression: "form.webBill"
    }
  })], 1)], 1)], 1)], 1), _c('section', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('h6', [_vm._v("BANK ACCOUNT")])]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Beneficiary"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.form.bankAccountName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "bankAccountName", $$v);
      },
      expression: "form.bankAccountName"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Bank Name"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.form.bankName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "bankName", $$v);
      },
      expression: "form.bankName"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Bank Account"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: _vm.form.bankAccountNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "bankAccountNumber", $$v);
      },
      expression: "form.bankAccountNumber"
    }
  })], 1)], 1)], 1)], 1)])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeTab == 'contact',
      expression: "activeTab == 'contact'"
    }]
  }, [_c('FormCustomerListContact', {
    attrs: {
      "contacts": _vm.contacts
    },
    on: {
      "update:contacts": function updateContacts($event) {
        _vm.contacts = $event;
      },
      "deleteBulk": _vm.deleteBulkContact
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeTab == 'document',
      expression: "activeTab == 'document'"
    }]
  }, [_c('FormCustomerDocument', {
    attrs: {
      "documents": _vm.documents
    },
    on: {
      "update:documents": function updateDocuments($event) {
        _vm.documents = $event;
      },
      "deleteBulk": _vm.deleteBulkDocument
    }
  })], 1), !_vm.isFormShippment ? _c('b-row', {
    staticClass: "mt-4"
  }, [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-button', {
    staticClass: "w-100",
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v(" Cancel & Close ")])], 1), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-button', {
    staticClass: "w-100",
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v(" Submit ")])], 1)], 1) : _vm._e()], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }